module.exports = __webpack_public_path__ + "static/img_young-woman-5e3af7991d1d2600d4c1021062f2eb95.png";